import React, { Component } from "react";
import { useState, useEffect } from 'react'
import store from "@/redux/store";
import { open, close, setPos } from '@/reducers/Window'
import {WINDOW} from "@/actions/globalConst";

import { MagnifyingGlassIcon, QuestionMarkCircleIcon } from '@heroicons/react/20/solid'
import {
  Bars3Icon,
  BellIcon,
  CogIcon,
  CreditCardIcon,
  KeyIcon,
  SquaresPlusIcon,
  UserCircleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'


import { BuildingOfficeIcon, UserIcon, UsersIcon, PencilIcon, TrashIcon } from '@heroicons/react/20/solid'

import { Company } from "@/views/Settings/Company";
import { Invoice } from "@/views/Settings/Invoice";
import { Interest } from "@/views/base/user/Interest";
import {storeBaseSetting2, removeBaseSetting} from "@/reducers/Settings";
import {showConfirmModal, hideModal} from "@/reducers/ModalPopup";
import DateHelper from "@/helpers/DateHelper";
import { PPCTimeField } from "@/components/datetime/PPCTimeField";

import {Collection} from "@/models/base/Collection";

interface IAction {
    type: string,
    item: object|null
}
const Action = {
    type: "",
    item: null
}
export function WorkhoursSettingsView({...props}) {
    const ACTIONS = {
        ADD: "ADD",
        EDIT: "EDIT"
    } 
    const [workhours, setWorkhours] = useState<Collection|null>( ((props.SettingsReducer && props.SettingsReducer.workhours) ? props.SettingsReducer.workhours : []) );
    const [action, setAction] = useState<IAction|null>();

    useEffect(() => {
        
        if(!workhours) {
            const state = store.getState();
            const {TenantReducer} = state;
            const {settings} = TenantReducer;
            
            setWorkhours(settings.workhours)
            //props.invoiceRow.timeregistrations = props.data; //DB.newCollection(props?.data);
            //setTableItems(props.invoiceRow.timeregistrations);
        }
        return () => {
        };
      }, [workhours]);    

          const saveItem = (event) => {
              event.preventDefault();
              event.stopPropagation();

              store.dispatch( storeBaseSetting2( {data: {workhours:workhours.getData()}, type: "workhours"} ) );

      //        setAction( "" );
              return false;

          }    
      
      
      const onAddWorkItemEvent= (event, item) => {
                let currentPos = event.target.getBoundingClientRect();
                store.dispatch( open({childWindow:WINDOW.WORKHOURS_ITEM_EDIT, title: 'Nieuwe werktijd regel', width:400, height:100, x: currentPos.x, y:currentPos.y+window.scrollY,
                    onCloseHandler: saveItem,  
                    data: {workhourItem: item.createRule(), dayItem:item, type:1 }}) );

        //        setAction({type:ACTIONS.EDIT, item: item});
                
                return false;
        
        }
      const deleteWorkItem= (event,item,parent) => {
        event.preventDefault();
        event.stopPropagation();
        let result = parent.deleteRule(item);

        store.dispatch( storeBaseSetting2( {data: {workhours:workhours.getData()}, type: "workhours"} ) );
                
        return false;
      }
      
      const  editWorkItem= (event, item, parent) => {
        let currentPos = event.target.getBoundingClientRect();
        store.dispatch( open({childWindow:WINDOW.WORKHOURS_ITEM_EDIT, title: 'Bewerken werktijd', width:400, height:100, x: currentPos.x, y:currentPos.y+window.scrollY,
            onCloseHandler: saveItem,  
            data: {workhourItem: item, dayItem:parent, type:2}}) );

//        setAction({type:ACTIONS.EDIT, item: item});
        
        return false;
      }    
 
 let timeInMinutes = DateHelper.getTotalminutesFromStr("17:34");
 DateHelper.getTimeStrFromMinutes(timeInMinutes);
 DateHelper.getTimeStrFromMinutes(234);
//    const {settings_vatrates} = SettingsReducer;
         return (
<form onSubmit={() => {return null}}>


                  <div className="shadow sm:overflow-hidden sm:rounded-md">
                    <div className="bg-white px-4 py-6 sm:p-6">
                        {workhours && workhours.length > 0 && 
          <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 w-12">
                    Dag
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 ">
                    Werkuren van/tot
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {workhours  && workhours.map((item) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <span>{item.dayName}</span>
                        <PencilIcon className="w-3 h-5 cursor-pointer" 
                         onClick={(event) => onAddWorkItemEvent(event, item)}
                        />
                        
                         
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {(item?.workhourrule && item?.workhourrule instanceof Collection && item?.workhourrule.length > 0)  && item.workhourrule.map((workhourItem) => (
                        <>
                        {(() => {
                        if(action && action.type == ACTIONS.EDIT && action.item && action?.item['uid'] == workhourItem.uid) {
                        return (<label className="flex">
                            
                            <PPCTimeField
                                //onChangeHandler={setValue}
//                             onChange={(name, time) => {setValue(name, time);}} 
                             name="start"  
                             hourCycle={24} 
//                             defaultValue={(props?.window?.data?.workhours)  ? props?.window?.data?.workhours :  ((typeof data == 'object') ? data.getTotalTimeInMinutes() : 0)}
//                             key={((typeof data == 'object') ? data.getTotalTimeInMinutes() : 0)}
                             lblHour={'uur'} lblMinute={'min'}/>
</label>                        )    
                        } else {
                            return (<label className="flex">
                                <PencilIcon className="w-3 h-5 cursor-pointer" 
                                onClick={() => deleteWorkItem(event, workhourItem, item)}
                                />
                            <PencilIcon className="w-3 h-5 cursor-pointer" 
                            onClick={() => editWorkItem(event, workhourItem, item)}
                            />
                        
                           <span className="w-24">{workhourItem.label}</span>
                           <span className="w-24">Start: {workhourItem.start}</span>
                           <span>Eind: {workhourItem.end}</span>
                        </label>)
                           }
                           })()}
                           </>
                        ))}
                    </td>
                        
                        
                    </tr>                        
                ))}
              </tbody>
            </table>
            }
                    </div>
                    
                    <div className="bg-gray-50 px-4 py-3 text-right sm:px-6">
                        <>
                      <button
                        type="button"
                        //onClick={() => cancel(event)}
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Annuleren
                      </button>
 
                      <button
                        type="submit"
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Bewaren
                      </button>
                      </>
                      
                      
                    </div>
                    
                  </div>
                  
                </form>
    );    
}